import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'

import { alertActions, loaderActions, regisActions, authActions } from '../../../store/actions'
import history from '../../../route/history'
import KTnetModal4 from '../../../module/ktnet/KTnetModal4'
import Pcc from '../../../module/cert/Pcc/PccV4'
import Input from '../../../module/input/CustomInput'
import { regConstants } from '../../../store/constants'
import { valid } from '../../../hook/valid'
import validPassword from '../../../hook/valid/password'
import * as common from '../../../assets/js/common.js'
import PccMobile from '../../../module/cert/Pcc/PccV4Mobile'
import { commons } from '../../../hook/common'
import { findAllInRenderedTree } from 'react-dom/test-utils'
import { isMobile } from 'react-device-detect'
import {replace} from "lodash/string";
import userinfo from "../../../store/reducers/userinfo/userinfo.reducer";

const RegisSimpleCompany = (props) => {
  // 공인인증 툴킷open 여부
  const [isKTnetOpen, setIsKTnetOpen] = useState(false)

  // 본인인증popup open 여부
  const [isPccOpen, setIsPccOpen] = useState(false)

  const [state, setState] = useState({
    isZipOpen: false,
    isCompanyZipOpen: false,
    submitted: false,
    isJoin: false, //가입여부체크
    checkedId: false, //아이디 중복체크
    checkedRegistNo: false, //사업자번호 정상체크
    uthInfo: '',
    userInfo: props.userInfo,
  })

  const nodeBaseInfo = {
    groupName: {
      className: 'form-keyword',
      type: 'text',
      title: '사업자/단체명',
      message: '사업자/단체명을 입력하세요',
      placeholder: '사업자/단체명을 입력하세요',
      required: true,
      length: 30,
    },
    groupRegistno: {
      className: 'form-keyword',
      wrapperClassWidth: 'inherit',
      type: 'number',
      title: '사업자등록번호',
      placeholder: "(' - ')없이 입력하세요.",
      message: '사업자등록번호를 입력하세요.',
      length: 10,
      required: true,
      readOnly: true,
      withBtn: true,
      withBtnName: '조회',
      withBtnClick: () => {
        checkRegisNo('')
      },
    },
    memberId: {
      className: 'form-keyword',
      wrapperClassWidth: 'inherit',
      type: 'text',
      title: '담당자 아이디',
      message: '담당자 아이디를 입력하세요.',
      placeholder: '담당자 아이디를 입력하세요.',
      required: true,
      length: 40,
      regex: regConstants.id,
      regErrMsg: '담당자 아이디는 4~30자 영어 대소문자, 숫자만 입력 가능합니다.',
      withBtn: true,
      withBtnName: '중복체크',
      withBtnClick: () => validId('memberId', ''),
    },
    passwd: {
      className: 'form-keyword',
      type: 'password',
      title: '비밀번호',
      message: '비밀번호를 입력하세요.',
      placeholder: '비밀번호를 입력하세요.',
      required: true,
      length: 20,
      regex: regConstants.pwd,
      regErrMsg: '비밀번호 유효형식 정의 필요합니다.', //FIXME
    },
    passwdAgain: {
      className: 'form-keyword',
      type: 'password',
      title: '비밀번호',
      message: '비밀번호를 다시 입력하세요.',
      placeholder: '비밀번호를 다시 입력하세요.',
      required: true,
      length: 20,
      regex: regConstants.pwd,
      regErrMsg: '비밀번호 유효형식 정의 필요합니다.', //FIXME
    },
    memberName: {
      className: 'form-keyword',
      type: 'text',
      title: '이름',
      // message: '이름을 입력하세요',
      placeholder: '본인인증 시 이름은 자동으로 입력됩니다.',
      readOnly: true,
      required: true,
      length: 15,
    },

    email: {
      className: 'form-keyword',
      type: 'text',
      title: '이메일',
      message: '이메일을 입력하세요',
      placeholder: '이메일을 입력하세요',
      required: false,
      length: 100,
      regex: regConstants.email,
      regErrMsg: '이메일 주소 형식이 아닙니다.',
    },

    mobileNo: {
      className: 'form-keyword disabled',
      wrapperClassWidth: 'inherit',
      type: 'text',
      title: '휴대폰 번호',
      placeholder: '본인인증을 진행해주세요.',
      message: '본인인증',
      readOnly: true,
      length: 20,
      required: true,
      withBtn: true,
      regErrMsg: '본인인증이 인증되지 않았습니다. 본인인증을 진행해주세요.',
      withBtnName: '본인인증',
      withBtnClick: () => {
        setIsPccOpen(true)
      },
    },
  }

  function objectToString(key) {
    let info = ''
    if (props.match.params?.[key] != null && props.match.params?.[key] != undefined) {
      info = Object.values(props.match.params?.[key])
      info = info.toString().replaceAll(',','')
    }
    return info
  }
  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    ...userInfo,
    almEmailYn: 'N',
    almKakaoYn: 'N',
    almSmsYn: 'N',
    almPushYn: 'N',
    userSeCd: '', // 담당자구분-A : 업무관리자 - N : 업무담당자
    mobileCertDt: '' /* 핸드폰 번호 */,
    certCi: '' /* 핸드폰 CI값 */,
    ktnetCertYn: 'Y',
    joinSeCd: '',

    groupName: objectToString('groupName'),
    groupRegistno: objectToString('groupRegistno'),
    memberName: objectToString('memberName'),
    mobileNo: objectToString('mobileNo'),
    email: objectToString('email'),
  })

  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))

  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })

  const certRadioHandler = (e) => {
    const { id } = e.target

    setCertChkInfo((certChkInfo) => ({
      ...certChkInfo,
      certChkYn: id === 'certChkYnY' ? 'Y' : 'N',
    }))
  }

  /**
   * 약관동의 체크
   */
  useEffect(() => {
    props.setJoinFlag('link')

    let agreeInfo = props.location.state?.agreeInfo
    let obj = {}

    if (!agreeInfo) {
      history.replace({pathname: '/regis/simple',  state: { type: 'link', userInfo }})
      return
    } else {
      history.replace({pathname: '/regis/simpleCompany', state: {type: 'link', agreeInfo}})
    }

    Object.keys(agreeInfo).forEach((key) => {
      obj[key] = agreeInfo[key]?.agree === true ? 'Y' : 'N'
    })

    // 신규회원일경우
    if (props.uthInfo?.uthId === undefined) {
      obj['userSeCd'] = '02' // 법인관리회원
      obj['joinSeCd'] = '04' // Paperless(일반) 로그인 사용자
    }

    setUserInfo({
      ...userInfo,
      ...obj,
    })
    commons.preventKeyDown()
    console.log(isMobile)
  }, [])

  //담당자 아이디 정보 갱신
  useEffect(() => {
    let obj = {
      withBtnClick: () => validId('memberId', userInfo?.memberId),
    }

    if (props.checkedId === true) {
      props.checkResetId()
      obj.withBtnName = '중복체크'
    }

    handleChangeNode('memberId', obj)
  }, [userInfo?.memberId])

  //담당자 중복체크 콜백
  useEffect(() => {
    if (props.checkedId === true) {
      props.success({
        title: '담당자 아이디',
        message: '사용 가능한 아이디입니다.',
      })

      handleChangeNode('memberId', {
        errMessage: null,
        withBtnName: '확인완료',
        withBtnClick: () => validId('memberId', userInfo?.memberId),
      })
    } else {
      handleChangeNode('memberId', {
        withBtnName: '중복체크',
        withBtnClick: () => validId('memberId', userInfo?.memberId),
      })
    }
  }, [props.checkedId])

  //사업자등록번호 조회 콜백
  useEffect(() => {
    console.log("didmount  ;",didMount)
    if (props.checkedRgsNo === true) {
      handleChangeNode('groupRegistno', {
        errMessage: null,
        withBtnName: '확인완료',
        withBtnClick: () => checkRegisNo(userInfo?.groupRegistno),
      })
    } else {
      props.checkDuplBizNoYN(false)
      handleChangeNode('groupRegistno', {
        withBtnName: '조회',
        withBtnClick: () => checkRegisNo(userInfo?.groupRegistno),
      })
    }
  }, [props.checkedRgsNo])

  //사업자정보 갱신
  useEffect(() => {
    if (props.checkedRgsNo === true) {
      props.checkResetRgsNo(false)
    }

    handleChangeNode('groupRegistNo', {
      withBtnName: '조회',
      withBtnClick: () => checkRegisNo(userInfo?.groupRegistNo),
    })
  }, [userInfo?.groupRegistNo])

  //가입완료처리
  useEffect(() => {
    if (props.isJoin === true) {
      history.push({ pathname: '/regis/success/' + userInfo?.memberId })
    }
  }, [props.isJoin])

  useEffect(() => {
    if (props.uthInfo !== undefined) {
      setUserInfo({
        ...userInfo,
        groupName: props.uthInfo?.companyNm /* 사업자명 */,
        groupRegistNo: props.uthInfo?.companyNo /* 사업자등록번호 */,
        memberName: props.uthInfo?.userNm /* 담당자 이름 */,
        email: props.uthInfo?.email /* 이메일 */,
        memberId: props.uthInfo?.uthId,
        passwd: props.uthInfo?.uthPasswd,
        uthId: props.uthInfo?.uthId,
        uthPasswd: props.uthInfo?.uthPasswd,
        userSeCd: '02',
        joinSeCd: '05', // 가입구분코드: uTradeHub 로그인 사용자
      })
      if (props.uthInfo?.uthId === undefined) {
        // 신규회원일경우
        setUserInfo({
          ...userInfo,
          userSeCd: '02',
          joinSeCd: '04',
        })
      }
    }
  }, [props.uthInfo])

  // 본인인증 받은 cellNo userInfo정보 넣기 위함
  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      mobileNo: props.cellNo,
    }))
    // if(props.cellNo != null && props.cellNo != '') {
    //   if(!props.cellNo.equals(userInfo.mobileNo)) {
    //     return props.error({ message: '본인인증한 휴대폰번호와 등록된 휴대폰번호가 일치하지 않습니다.' })
    //   }
    // }
  }, [props.cellNo])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      mobileCertDt: props.certDate,
    }))
  }, [props.certDate])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      certCi: props.certCi,
    }))

    // 휴대폰번호, 인증CI값 중복체크 userSeCd: 02(법인관리회원)
    if (props.cellNo && props.certCi) {
      props.checkMobile('02', props.cellNo, props.certCi)
    }
  }, [props.certCi])

  // 공동인증여부에 따른 회원가입 사용자 상태
  // => 공동인증없이 가입한 사용자는 대기상태(W)로
  // => 공동인증있이 가입한 사용자는 정상상태(A)로 처리
  useEffect(() => {
    if (props.uthInfo?.uthId === undefined) {
      //신규회원일경우에만 체크
      setUserInfo((userInfo) => ({
        ...userInfo,
        ktnetCertYn: certChkInfo.certChkYn,
      }))
    }
  }, [certChkInfo.certChkYn])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      memberName: props.certName,
    }))
    // if(props.certName != null && props.certName != '') {
    //   if(!props.certName.equals(userInfo.memberName)) {
    //     return props.error({ message: '본인인증한 성명과 등록된 성명이 일치하지 않습니다.' })
    //   }
    // }
  }, [props.certName])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      nativeYn: props.fgnGbn === '1' ? 'Y' : 'N', // 1-내국인, 2-외국인
    }))
  }, [props.fgnGbn])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      genderCd: props.sex,
    }))
  }, [props.sex])

  useEffect(() => {
    setUserInfo((userInfo) => ({
      ...userInfo,
      birthDay: props.birYMD,
    }))
  }, [props.birYMD])

  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current){
      didMount.current=true
      return
    }
    if (props.isDuplBizNo) {
      if(props.checkedRgsNo){
        props.error({ title: '확인', message: '정상 확인되었습니다.' })
        props.checkedRegistNo(true)
      }else{
        props.error({ message: '사업자 번호를 확인해주세요. \n 맞으시면 가입 진행해주시기 바랍니다.' })
        props.checkedRegistNo(true)
        props.setDuplBizNo(false)
      }
    }

    setUserInfo((userInfo) => ({
      ...userInfo,
      isDuplBizNo: props.isDuplBizNo,
    }))
  }, [props.isDuplBizNo])

  /**
   * 아이디 중복체크
   * @param key :사업자아이디, 이용자 아이디
   * @param value
   */
  const validId = (key, value) => {
    if (value?.length === undefined) {
      return props.error({ message: '담당자 아이디를 입력하세요.' })
    }
    if (value?.length < 4) {
      return props.error({ message: '아이디는 최소 4자리 이상입니다.' })
    }

    if (key === 'memberId') {
      if (!props.checkedId) {
        nodeInfo[key]?.regex.test(value) ? props.checkMemberId(value) : props.error({ message: nodeInfo[key]?.regErrMsg })
      }
    }
  }

  /**
   * 인증서 콜백
   * @param info
   */
   const crtfctInfo = (info) => {
    console.log('info : ', info)
    props.passCrtfctfLogin(info, '3',"N")
  }

  /**
   * 다음화면 진입전 유효성 체크
   */
  const goNext = () => {
    setState({ ...state, submitted: !state.submitted })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!userInfo?.[key] || userInfo?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      //유효성 체크
      if (message === null && userInfo?.[key]?.length > 0 && !!node[key].regex) {
        let regex = node[key].regex
        let value = userInfo?.[key]
        let regResult = regex.test(value)

        if (!regResult) {
          message = node[key]?.regErrMsg
          errCnt++
        } else {
          message = null
        }
      }

      //비밀번호 유효성 체크
      if (key === 'passwd') {
        let pwdError = validPassword({ password: userInfo.passwd, id: userInfo.memberId })
        if (pwdError && pwdError?.length > 0) {
          message = pwdError
          errCnt++
        }
      }

      // 휴대폰번호 본인인증 인증 필수체크
      if (key === 'mobileNo') {
        if (!userInfo.mobileNo) {
          message = node[key]?.regErrMsg
        } else {
          message = null
        }
      }

      if (errCnt === 1 && key === 'mobileNo') {
        if (!userInfo.mobileNo) {
          return props.error({ message: '휴대폰 번호 본인인증이 인증되지 않았습니다.\n 본인인증을 진행해주세요.' })
        }
      }
      // 휴대폰번호 본인인증 인증 끝
      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    }) // 반복문 종료

    if (errCnt > 0) {
      return
    } else {
      if (!props.checkedId) {
        return props.error({ message: '담당자 아이디 중복체크를 해주세요.' })
      }
      // if (!props.checkedRgsNo) {
      //   return props.error({ message: '사업자 등록번호를 조회해주세요.' })
      // }
      if (userInfo.passwd !== userInfo.passwdAgain) {
        return props.error({ message: '비밀번호가 일치하지 않습니다.\n 다시 확인해주세요.' })
      }

      //신규회원일경우에만 공인인증처리
      if (props.uthInfo?.uthId === undefined) {
        if (certChkInfo.certChkYn === 'Y' && !certChkInfo.signCompleted) {
          return props.error({ message: '공인인증이 인증되지 않았습니다.\n 공인인증을 진행해주세요.' })
        }
      } else {
        // uth회원일경우는 공인인증처리 됬다고 생각
        setUserInfo((userInfo) => ({
          ...userInfo,
          ktnetCertYn: 'Y',
        }))
      }
    }

    // MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크
    if (props.checkMobileYn !== null && !props.checkMobileYn) {
      return props.error({ message: '해당 휴대폰 번호로 가입된 사용자가 존재합니다.' })
    }

    props.registManager(userInfo)
  }

  /**
   * 사업자 등록번호 확인
   * @param bizNo
   */
  const checkRegisNo = (bizNo) => {
    if (!bizNo) {
      return props.error({ message: '사업자 번호를 입력해주세요.' })
    }
    let checkResult = valid.checkbizNo(bizNo)
    // let checkResult = true // 사업자번호 없이 테스트할 때 사용하는 주석

    // props.error({ title: '확인', message: '정상 확인되었습니다.' })
    props.checkedRegistNo(checkResult)
    props.duplBizNo(bizNo)
    // if (!checkResult && !props.isDuplBizNo) {
      // props.error({ message: '정상적인 사업자 번호가 아닙니다.\n 다시 한번 사업자 번호를 확인해주시기 바랍니다.' })
      // checkResult = true;
    // }

    // console.log('사업자 번호 중복 체크, bizNo: ' + bizNo)
    // props.checkedRegistNo(checkResult)


  }

  /**
   * 인증서 툴킷 띄우기 전에 사업자 번호 확인
   * @param bizNo
   * @returns
   */
  const toolkitCheckRegisNo = (bizNo) => {
    if (!bizNo) {
      return props.error({ message: '사업자 번호를 입력해주세요.' })
    }

    let checkResult = valid.checkbizNo(bizNo)
    props.duplBizNo(bizNo)
    props.checkedRegistNo(checkResult)
    // let checkResult = true // 사업자번호 없이 테스트할 때 사용하는 주석
    // if (!checkResult) {
      // props.error({ message: '정상적인 사업자 번호가 아닙니다.\n 다시 한번 사업자 번호를 확인해주시기 바랍니다.' })
      // checkResult = true;
    // }

  }

  /**
   * 화면 표시된 node의 정보변경
   * @param nodeKey
   * @param changeObj
   */
  const handleChangeNode = (nodeKey, changeObj) => {
    setNodeInfo((nodeInfo) => ({
      ...nodeInfo,
      [nodeKey]: {
        ...nodeInfo?.[nodeKey],
        ...changeObj,
      },
    }))
  }

  /**
   * 가입용 사용자정보
   * @param e
   */
  const handleChange = (e) => {
    const { id, value } = e.target

    setUserInfo({
      ...userInfo,
      [id]: value,
    })
  }

  const checkHandler = (e) => {
    const { id, checked } = e.target

    setUserInfo({
      ...userInfo,
      [id]: checked === true ? 'Y' : 'N',
    })
  }

  /**
   * 인풋태그 자동생성
   * @param key
   * @returns {JSX.Element}
   */
  const generateInput = (key) => {
    let className = ''
    const node = nodeInfo[key]
    let idx = Object.keys(nodeInfo).indexOf(key)
    // let info = ''
    // if (userInfo?.[key] != null && userInfo?.[key] != undefined) {
    //   info = Object.values(userInfo?.[key])
    //   info = info.toString().replaceAll(',','')
    // }
    return (
      <Input
        type={node.type}
        className={className + (node.className != undefined ? ' ' + node.className : '')}
        wrapperClassWidth={node.wrapperClassWidth}
        id={key}
        name={key}
        // title={node.title}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        autoComplete="off"
        value={userInfo?.[key]|| ''}
        placeholder={node.placeholder}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={node.wrapperClassName}
        message={node.message}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        required={node.required}
        onChange={handleChange}
        readOnly={node.readOnly}
        length={node.length}
        withBtn={node.withBtn}
        withBtnName={node.withBtnName}
        withBtnClick={node.withBtnClick}
        submitted={state.submitted}
        errMessage={node.errMessage}
      />
    )
  }

  return (
    <React.Fragment>
      <div id="contents">
        <div className="content-header type2">
          {/* mobile 뒤로가기 버튼 */}
          <a
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          <h2>회원가입</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <em>회원가입</em>
          </div>
        </div>
        <div className="join-wrap">
          {/* <div className="guide-box">
            <ul>
              <li>KTNET 사이트 가입을 위한 약관동의 절차입니다.</li>
              <li>회원가입에 입력한 정보는 암호화되어 안전하게 보관되어 집니다.</li>
              <li>약관을 동의하지 않을 경우 회원 가입에 제한이 있을 수 있습니다.</li>
              <li>추가적인 안내문구!!</li>
            </ul>
            <p className="emphasize">※ 전자무역문서지갑 회원은 만 14세 이상만 가입할 수 있습니다.</p>
          </div> */}
          <ul className="steps mt40">
            <li>
              <span className="num">1</span>약관동의
            </li>
            <li className="on">
              <span className="num">2</span>사업자/담당자정보
            </li>
            <li>
              <span className="num">3</span>가입완료
            </li>
          </ul>
          <h3 className="h3-tit">사업자 / 단체 회원가입</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>사업자/단체명, 사업자등록번호항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 사업자/단체명
                </th>
                <td>
                  {props.match.params.groupName}
                  {/*{generateInput('groupName')} /!* 사업자명 *!/*/}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 사업자등록번호
                </th>
                <td>
                  <span className="inquiry-group">
                    {/*{props.match.params.groupRegistNo}*/}
                    {generateInput('groupRegistno')} {/* 사업자등록번호 */}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          {/*<KTnetModal4*/}
          {/*  groupRegistno={userInfo?.groupRegistno || ''}*/}
          {/*  isKTnetOpen={isKTnetOpen}*/}
          {/*  onChange={() => setIsKTnetOpen(false)}*/}
          {/*  sendCrtfctInfo={crtfctInfo}*/}
          {/*  changeSignComplete={() => setCertChkInfo((certChkInfo) => ({ ...certChkInfo, signCompleted: true }))}*/}
          {/*  error={props.error}*/}
          {/*/>*/}

          <h3 className="h3-tit">담당자 회원가입</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <p className="required" style={{color:"black"}}>디지털시험성적서 이용고객은 본인인증 시 <u style={{color:"#0674d6"}}>시험인증기관에 접수한 수령처 담당자 정보</u>로 인증하여 주시기 바랍니다.</p>
          <p className="required" style={{color:"black"}}>( <span style={{color:"#0674d6"}}>①사업자번호 ②담당자명 ③담당자 연락처 정보</span>가 동일해야 성적서를 받아보실 수 있습니다. )</p>
          <table className="tbl-write">
            <caption>담당자 아이디, 비밀번호, 비밀번호 확인, 이름, 부서 및 직급, 이메일, 휴대폰 번호 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 담당자 아이디
                </th>
                <td>
                  <span className="inquiry-group">
                    {generateInput('memberId')} {/* 아이디 */}
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 비밀번호
                </th>
                <td>
                  {generateInput('passwd')} {/* 비밀번호 */}
                  <p className="desc">
                    ※ 영문, 숫자, 특수문자 중 2종류를 조합 10~16자 (3종류 8~16자리)로 설정
                    {/* <br /> ※ 특수문자는 숫자 키보드 위의 [!@#$%^&amp;*_+{'}'}만 가능 */}
                  </p>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 비밀번호 확인
                </th>
                <td>
                  {generateInput('passwdAgain')} {/* 비밀번호 확인 */}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 휴대폰 번호
                </th>
                <td>
                  <span className="inquiry-group">
                    {generateInput('mobileNo')} {/* 핸드폰번호 */}
                    {common.getDeviceType() !== 'MobileApp' || common.getDeviceType =='MobileWeb' ? ( // 모바일 웹은 pccMobile로 간다.
                      <Pcc isPccOpen={isPccOpen} memberId={userInfo?.memberId} onChange={() => setIsPccOpen(false)} />
                    ) : (
                      <PccMobile isPccOpen={isPccOpen} memberId={userInfo?.memberId} onChange={() => setIsPccOpen(false)} />
                    )}
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 이름
                </th>
                <td>
                  {generateInput('memberName')} {/* 이름 */}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em /> 이메일
                </th>
                <td>
                  {generateInput('email')} {/* 이메일 */}
                </td>
              </tr>

            </tbody>
          </table>
          <h3 className="h3-tit">알람 수신 동의 (선택)</h3>
          <p className="required">* 전자문서지갑에 성적서 수신 시 알림을 원하는 고객은 알람정보를 수신 동의하여 주시기 바랍니다.</p>
          <div className="check-box">
            <span className="check-group">
              <input title="이메일 수신동의" type="checkbox" id="almEmailYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almEmailYn">E-mail 수신 동의</label>
              <input title="푸쉬알림 수신동의" type="checkbox" id="almPushYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almPushYn">푸시 알림 수신 동의</label>
              {/* <input title="알림톡 수신동의" type="checkbox" id="almKakaoYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almKakaoYn">알람톡 수신 동의</label> */}
              <input title="SMS 수신동의" type="checkbox" id="almSmsYn" onChange={checkHandler} />
              <em />
              <label htmlFor="almSmsYn">SMS 수신 동의</label>
            </span>
          </div>
          <div className="btn-block center">
            <a className="btn-primary lg cursor" onClick={goNext}>
              다음 단계로
            </a>
          </div>
        </div>
      </div>
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.regis,
    isJoin: state.regis.isJoin,
    checkedId: state.regis.checkedId,
    checkedRgsNo: state.regis.checkedRegistNo,
    isDuplBizNo: state.regis.isDuplBizNo,
    checkMobileYn: state.regis.checkMobileYn,
    uthInfo: state.regis?.uthInfo?.data?.payload,
    cellNo: state.certificate.resultInfo.cellNo,
    certDate: state.certificate.resultInfo.certDate,
    certName: state.certificate.resultInfo.name,
    certCi: state.certificate.resultInfo.ci1,
    fgnGbn: state.certificate.resultInfo.fgnGbn,
    sex: state.certificate.resultInfo.sex,
    birYMD: state.certificate.resultInfo.birYMD,

    //userInfo: state.regis.userInfo,
    // groupName: state.userInfo.groupName,
    // groupRegistNo: state.userInfo.groupRegistNo,
    // memberName: state.userInfo.memberName,
    // mobileNo: state.userInfo.mobileNo,
  }
}



const actionCreators = {
  registManager: regisActions.registManager,
  checkMemberId: regisActions.checkMemberId,
  checkResetGroupId: regisActions.checkResetGroupId,
  checkResetId: regisActions.checkResetId,
  checkResetRgsNo: regisActions.checkResetRgsNo,
  checkedRegistNo: regisActions.checkedRegistNo,
  loading: loaderActions.loading,
  error: alertActions.error,
  success: alertActions.success,
  getUthInfo: regisActions.getUthInfo,
  checkMobile: regisActions.checkMobile,
  duplBizNo: regisActions.duplBizNo,
  passCrtfctfLogin: authActions.passCrtfctfLogin,
  checkDuplBizNoYN:regisActions.checkDuplBizNoYN,
  setDuplBizNo:regisActions.setDuplBizNo,

  setJoinFlag: regisActions.setJoinFlag,
}

export default connect(mapStateToProps, actionCreators)(RegisSimpleCompany)
